var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.message
        ? _c("span", { staticClass: "text-danger" }, [
            _vm._v(" " + _vm._s(_vm.message) + " ")
          ])
        : _vm._e(),
      _c("v-simple-table", {
        staticStyle: { "margin-bottom": "10px" },
        style: { width: _vm.widthTable },
        attrs: { id: _vm._id },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _vm._l(_vm.columns, function(c, ind) {
                        return _c(
                          "th",
                          { key: "headers-" + ind, staticClass: "text-left" },
                          [_vm._v(" " + _vm._s(c) + " ")]
                        )
                      }),
                      _vm._l(_vm.actions.length, function(i) {
                        return _c("th", { key: "header-" + i })
                      })
                    ],
                    2
                  )
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.rows, function(r, index) {
                    return _c(
                      "tr",
                      {
                        key: "linha-" + index,
                        class: {
                          "bg-danger": _vm.isDuplicated(r)
                        }
                      },
                      [
                        _vm._l(_vm.orderColumnsRows(r), function(d, iColumn) {
                          return _c(
                            "td",
                            {
                              key: "coluna-" + iColumn,
                              class: d[1] ? d[1].html_classes : "",
                              style: d[1] ? d[1].html_style : ""
                            },
                            [
                              d[1] && d[1].data_ok
                                ? _c(
                                    "div",
                                    [
                                      !_vm.canEdit
                                        ? _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(d[1].data_parsed) +
                                                " "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm.canEdit
                                        ? _c("v-text-field", {
                                            staticClass: "mb-2 pt-0",
                                            attrs: {
                                              "hide-details": "",
                                              dense: "",
                                              placeholder:
                                                d[0] + _vm.allRequired
                                                  ? "*"
                                                  : "",
                                              required: _vm.allRequired,
                                              rules: _vm.allRequired
                                                ? [_vm.rules.required]
                                                : null
                                            },
                                            model: {
                                              value: d[1].data_parsed,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  d[1],
                                                  "data_parsed",
                                                  $$v
                                                )
                                              },
                                              expression: "d[1].data_parsed"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              d[1] && !d[1].data_ok
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "div",
                                                  _vm._g(
                                                    {
                                                      staticStyle: {
                                                        height: "100%",
                                                        width: "100%",
                                                        "justify-content":
                                                          "center",
                                                        "align-items": "center",
                                                        display: "flex"
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    !_vm.canEdit
                                                      ? _c(
                                                          "span",
                                                          _vm._g({}, on),
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  d[1]
                                                                    .data_parsed ||
                                                                    " "
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm.canEdit
                                                      ? _c(
                                                          "v-text-field",
                                                          _vm._g(
                                                            {
                                                              model: {
                                                                value:
                                                                  d[1]
                                                                    .data_parsed,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    d[1],
                                                                    "data_parsed",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "d[1].data_parsed"
                                                              }
                                                            },
                                                            on
                                                          )
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(d[1].html_message))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        }),
                        _c(
                          "td",
                          _vm._l(_vm.actions, function(a, i) {
                            return _c(
                              "BaseButton",
                              {
                                key: "acao-" + i,
                                attrs: { primary: "", small: "" },
                                on: {
                                  click: function($event) {
                                    return a.action(r[_vm.idKey], r)
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(a.title) + " ")]
                            )
                          }),
                          1
                        ),
                        _vm.isDuplicated(r)
                          ? _c(
                              "small",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  left: "30px",
                                  "font-size": "10px"
                                }
                              },
                              [_vm._v(" Registro duplicado ")]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  }),
                  0
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }